module.exports = __webpack_public_path__ + "static/media/arrow-back.4140aee7.svg";